import { frontendURL } from '../../../dashboard/helper/URLHelper';
const Lists = () => import('./Index.vue');
const ListMembers = () => import('./ListMembers.vue');
const BlockList = () => import('./BlockList.vue');
const ContactManageView = () =>
  import(
    '../../../dashboard/routes/dashboard/contacts/pages/ContactManageView.vue'
  );

export default [
  {
    path: frontendURL('accounts/:accountId/lists'),
    name: 'list_dashboard',
    roles: ['administrator', 'agent'],
    component: Lists,
  },
  {
    path: frontendURL('accounts/:accountId/lists/block-list'),
    name: 'list_block_list',
    roles: ['administrator', 'agent'],
    component: BlockList,
  },
  {
    path: frontendURL('accounts/:accountId/lists/block-list/members/:memberId'),
    name: 'list_block_list_member_profile',
    roles: ['administrator', 'agent'],
    component: ContactManageView,
    props: route => ({ contactId: route.params.memberId }),
  },
  {
    path: frontendURL('accounts/:accountId/lists/:id'),
    name: 'list_members',
    roles: ['administrator', 'agent'],
    component: ListMembers,
    props: route => ({ listId: route.params.id }),
  },
  {
    path: frontendURL('accounts/:accountId/lists/:listId/members/:memberId'),
    name: 'list_member_profile',
    roles: ['administrator', 'agent'],
    component: ContactManageView,
    props: route => ({
      contactId: route.params.memberId,
      listId: route.params.listId,
    }),
  },
];
